// Community Internal People Management APIs

/**
 * @function ApiClient#AddInternalPeople
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} internalPeopleData
 * @param {any} imageFiles
 * @param {any} options = {}
 */
export async function AddInternalPeople(cid, internalPeopleData, imageFiles, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(internalPeopleData));
  if (imageFiles) {
    imageFiles.forEach((f) => {
      formData.append("Image", f);
    });
  }
  return await this._post(`/community/${cid}/internal_people`, formData, options);
}

/**
 * @function ApiClient#UpdateInternalPeople
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} internalPeopleData
 * @param {any} imageFiles
 * @param {any} options = {}
 */
export async function UpdateInternalPeople(cid, internalPeopleData, imageFiles, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(internalPeopleData));
  if (imageFiles) {
    imageFiles.forEach((f) => {
      formData.append("Image", f);
    });
  }
  return await this._put(`/community/${cid}/internal_people`, formData, options);
}

/**
 * @function ApiClient#GetInternalPeopleList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetInternalPeopleList(cid, { sortBy, sortDesc, page, itemsPerPage, search }, options = {}) {
  if (!search) search = "";
  return await this._get(`/community/${cid}/internal_people_list?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&ss=${search}`, options);
}

/**
 * @function ApiClient#GetInternalPeopleWithDepartmentList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} department
 * @param {any} options = {}
 */
export async function GetInternalPeopleWithDepartmentList(cid, department, options = {}) {
  if (!department) department = "";
  return await this._get(`/community/${cid}/internal_people_list_department?d=${department}`, options);
}

/**
 * @function ApiClient#DeleteInternalPeople
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} vID
 * @param {any} options = {}
 */
export async function DeleteInternalPeople(cid, vID, options = {}) {
  return await this._delete(`/community/${cid}/internal_people/${vID}`, options);
}

/**
 * @function ApiClient#ImportInternalPeopleList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} xlsxFile
 * @param {any} options = {}
 */
export async function ImportInternalPeopleList(cid, xlsxFile, options = {}) {
  const formData = new FormData();
  formData.set("Xlsx", xlsxFile);
  return await this._post(`/community/${cid}/internal_people/import`, formData, options);
}

/**
 * @function ApiClient#GetCommunityAdminCanBindInternalPeopleUserList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetCommunityAdminCanBindInternalPeopleUserList(cid, options = {}) {
  return await this._get(`/community/${cid}/internal_people/can_bind_user_list`, options);
}

/**
 * @function ApiClient#BindInternalPeopleUser
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} internalPeopleID
 * @param {any} userID
 * @param {any} options = {}
 */
export async function BindInternalPeopleUser(cid, internalPeopleID, userID, options = {}) {
  return await this._post(`/community/${cid}/internal_people/${internalPeopleID}/bind/${userID}`, null, options);
}

/**
 * @function ApiClient#UnbindInternalPeopleUser
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} internalPeopleID
 * @param {any} options = {}
 */
export async function UnbindInternalPeopleUser(cid, internalPeopleID, options = {}) {
  return await this._delete(`/community/${cid}/internal_people/${internalPeopleID}/bind`, options);
}
